import { createStore } from "vuex";

export interface User {
  chain_code: string;
  customer_code: string;
  shop_code: string;
  token: string;
  user_id: string;
}

export interface RootState {
  user: User | null;
  listEdit: boolean;
}

export default createStore<RootState>({
  state: {
    user: null,
    // 編集フラグ
    listEdit: false,
  },
  getters: {
    // 編集フラグ
    listEditFlag(state) {
      return state.listEdit;
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    // 編集フラグ
    listEditOn(state) {
      state.listEdit = true;
    },
    listEditOff(state) {
      state.listEdit = false;
    },
  },
  actions: {},
  modules: {},
});
